import { render } from "./WidgetKpi.vue?vue&type=template&id=2b352a66&scoped=true"
import script from "./WidgetKpi.vue?vue&type=script&lang=js"
export * from "./WidgetKpi.vue?vue&type=script&lang=js"

import "./WidgetKpi.vue?vue&type=style&index=0&id=2b352a66&lang=scss&scoped=true"
import "./WidgetKpi.vue?vue&type=style&index=1&id=2b352a66&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b352a66"]])

export default __exports__